import React, { Suspense } from 'react'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import Card from 'src/components/Card'
import useToggleState from 'src/hooks/useToggleState'
import Body from './Body'
import List from './List'
import EditModel from './EditModal'

interface OnboardingProps {
  id: string
}

const Onboarding: React.FC<OnboardingProps> = (props) => {
  const { id } = props
  const [isOpen, , handleToggle] = useToggleState()

  return (
    <>
      <Card
        title='Onboarding Process'
        primaryAction={{
          key: 'edit',
          icon: faPencil,
          onClick: handleToggle,
          permissionKey: 'CAT_EDIT'
        }}
      >
        <Suspense fallback={<List contract={undefined} />}>
          <Body id={id} />
        </Suspense>
      </Card>
      <EditModel id={id} isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default Onboarding
